import { Address } from "./account/address";

export interface Facility {
    Id: number;
    Name: string;
    FacilityType: FacilityType;
    ParentFacilityId?: number;
    RequireInmateId: boolean;
    RequireReturnAddress: boolean;
    Address: Address;
    MaxNumberOfPhotos: number;
    DeliveryAssuranceEligible: boolean;
    IsProFacility: boolean;
    Rules: Array<FacilityRule>;
}

export enum FacilityType {
    Parent = 0,
    SubFacility = 1,
    Independent = 2
}

export interface FacilityRule {
    Id: number;
    Name: string;
    DisplayName: string;
    DisplayText: string;
    ImageUrl: string;
}

export enum FacilityJurisdiction {
    Federal = 0,
    State = 1,
    Local = 2
}